import { DateTime } from "luxon";

export function formatCurrency(input: number): string {
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(input);
}

export function dateRelative(dateIsoFormat: string): string | null {
  return DateTime.fromISO(dateIsoFormat).setLocale("pt-BR").toRelative();
}

type DisplayDate = string | Date | null | undefined;

function formatDisplayDate(value: DisplayDate, format: string): string {
  if (!value) return "—";
  // Parse calendar dates directly, without converting them from UTC midnight.
  let date =
    value instanceof Date
      ? DateTime.fromJSDate(value)
      : DateTime.fromISO(value);
  if (!date.isValid && typeof value === "string") {
    date = DateTime.fromSQL(value);
  }
  return date.isValid ? date.setLocale("pt-BR").toFormat(format) : "—";
}

export function dateToUser(value: DisplayDate): string {
  return formatDisplayDate(value, "dd/MM/yyyy");
}

export function dateToUserWithTime(value: DisplayDate): string {
  return formatDisplayDate(value, "dd/MM/yyyy HH:mm");
}

export function generateLinkWhatsapp(phone: string): string {
  return `https://api.whatsapp.com/send?phone=55${phone.replace(/[^\d]/g, "")}`;
}

const filters = {
  formatCurrency,
};
export default filters;
